<template>
  <wgu-map-overlay
    overlayId="tooltip-buffer"
    :visible=false
    autoPan
    :autoPanDuration="250"
    :offset="[0, 25]"
    positioning="top-center"
  >
    <template v-slot="{feature}">
<v-card
      width="auto"
      v-if="feature"
      style='border: 1px solid #0061a0;'
      >
    <v-btn
      elevation="1"
      color="#0061a0"
      icon
      class="ma-1"
      size="x-small"
      style="float:right;
      vertical-align: top;"
      @click="closeTooltip()"
    >
    <v-icon>md:close</v-icon>
    </v-btn>
      <!-- <v-img src="static/icon/damagepotential.jpg" height="100"/> -->
      <v-card-title>
        <span class="font-weight-light">
          {{ $t('tooltips.buffer.titel') + feature.get('description') }}
        </span>
      </v-card-title>
    </v-card>
</template>
  </wgu-map-overlay>
</template>

<script>
import MapOverlay from '../../src/components/modulecore/MapOverlay.vue'
import { WguEventBus } from '../../src/WguEventBus'
export default {
  name: 'tooltip-buffer',
  components: {
    'wgu-map-overlay': MapOverlay
  },
  methods: {
    closeTooltip () {
      WguEventBus.$emit('tooltip-buffer-update-overlay', false);
    }
  }
}
</script>
